import { getDataFromPocket } from '../../utils/pocket';
import { getPersonalizedSlices } from './utils-personalized-slices';
import type { DLParams, JobParams, RCParams } from './utils-pocket-models';

const BOGO_PAGE_DETAILS = 'Monthly Payment';
const BOGO_PAGE_DETAILS_OT = 'ot-content';
const HOME_PAGE_TYPE = 'Home page';

function hasPersonalizationOt(dlPageType?: string) {
    if (dlPageType !== HOME_PAGE_TYPE) return false;
    try {
        return localStorage.getItem('has-personalization-ot') === 'true';
    } catch {
        return false;
    }
}
const PURCHASING_SLICE_VERSION = 'version-5';
const PURCHASING_SLICE_NAME = 's-purchasing-cyber-protect';

function hasMonthlyPayment(vueState: any) {
    const purchasingSlice: any = vueState.pages?.page?.body?.find((x: any) => x.name === PURCHASING_SLICE_NAME);
    if (!purchasingSlice) return false;

    if (document.referrer.includes('account.acronis.com')) return false;

    const page: any = purchasingSlice.data?.page || {};
    if (page.version !== 5) return false;
    if (page.hasMonthlyPrice) return true;

    const countries: string[] = vueState.slices?.items?.[PURCHASING_SLICE_NAME]?.[PURCHASING_SLICE_VERSION]?.countries;
    if (!countries) return false;

    const geo: any = getDataFromPocket('geo', false);
    const country: string = geo?.data?.country?.code || '';
    return countries.includes(country);
}

export function sendBogoEvent() {
    const vueState = JSON.parse(document.getElementById('app-state')?.textContent ?? '{}');
    const finalLocale = vueState.geolocation?.finalLocale;

    const dlParams = getDataFromPocket<DLParams>('ga_dl_params', false) || {};
    const rcParams = getDataFromPocket<RCParams>('ga_rc_params', false) || {};
    const jobParams = getDataFromPocket<JobParams>('ga_job_params', false) || {};

    const splitsDimensionsPairs = (window.splitsCurrentActiveSet || [])
        .filter((x) => Boolean(x.dimension))
        .map((x) => [x.dimension, `${x.id}.${x.variant}`]);

    const dimensions = { ...Object.fromEntries(splitsDimensionsPairs) };

    const event = {
        event: 'BOGO',
        touchpoint: 'website',
        siteLocale: finalLocale || '(not set)',
        DL_PageType: dlParams.DL_PageType || '(not set)',
        DL_Audience: dlParams.DL_Audience || '(not set)',
        DL_Product: dlParams.DL_Product || '(not set)',
        rcProduct: rcParams.rcProduct || '(not set)',
        rcFeatured: rcParams.rcFeatured || '(not set)',
        rcCategory: rcParams.rcCategory || '(not set)',
        rcType: rcParams.rcType || '(not set)',
        ...jobParams,
        ...dimensions,
        ...(hasMonthlyPayment(vueState) && { pageDetailsA: BOGO_PAGE_DETAILS }),
        ...(hasPersonalizationOt(dlParams.DL_PageType) && { pageDetailsA: BOGO_PAGE_DETAILS_OT }),
    };

    const pageDetailsA = [event.pageDetailsA, getPersonalizedSlices(vueState)].filter(Boolean).join(' | ');

    window.dataLayer.push(pageDetailsA ? { ...event, pageDetailsA } : event);
}
